// extracted by mini-css-extract-plugin
module.exports = {"sub_wrap":"FloatingList_sub_wrap__1qLpz","table_ty1":"FloatingList_table_ty1__1xhb1"};